export default "__VITE_ASSET__616f7460__"